import React from 'react';

import { SidePage, Stack } from '@gogame/components';
import AITags from 'scenes/Gallery/components/AITags';

const AITagsTab = ({ data = [] }) => {
  return (
    <SidePage.NewBody wrapper={true}>
      <SidePage.NewContent withSidebar={false}>
        <Stack flex={1} pb={2}>
          <AITags data={data} />
        </Stack>
      </SidePage.NewContent>
    </SidePage.NewBody>
  );
};

export default AITagsTab;
